import { useState, useEffect } from "react"

const TOAST_LIMIT = 5
const TOAST_REMOVE_DELAY = 3000

// Estado global para los toasts
let globalToasts = [];
let listeners = new Set();

function notifyListeners() {
  listeners.forEach(listener => listener([...globalToasts]));
}

export function useToast() {
  const [toasts, setToasts] = useState(globalToasts);

  useEffect(() => {
    listeners.add(setToasts);
    return () => {
      listeners.delete(setToasts);
    };
  }, []);

  function toast({ autoDismiss = true, duration, ...props }) {
    const id = Math.random().toString(36).substr(2, 9);
    const newToast = { ...props, id, duration };
    
    globalToasts = [newToast, ...globalToasts].slice(0, TOAST_LIMIT);
    notifyListeners();

    const dismiss = () => {
      globalToasts = globalToasts.filter(t => t.id !== id);
      notifyListeners();
    };

    const removeDelay = typeof duration === "number" ? duration : TOAST_REMOVE_DELAY;
    if (autoDismiss && removeDelay > 0) {
      setTimeout(dismiss, removeDelay);
    }

    return {
      id,
      dismiss,
    };
  }

  return {
    toast,
    toasts,
  };
}
